import { registerTranslation } from 'nucleus-widgets/redux/modules/text';
import getMatchingLocale from '../../utils/getMatchingLocale';
import Logger from '@cvent/nucleus-logging';
const LOG = new Logger('languageManagementSettings');
/*
 * Redux action creator to push languageManagementSettings to guest text resolver.
 * Internally this just delegate to registerTranslation action creator from nucleus-widgets
 */
const createLoadLanguageManagementSettingsAction = (eventSettings, regPathSettings, guestText) => {
    if (!guestText || !guestText.locale || !guestText.resolver || !guestText.resolver.context) {
        LOG.warn('guest translation package not available');
        return;
    }
    const locale = guestText.locale;
    const context = guestText.resolver.context;
    const eventLanguageOverrides = (eventSettings === null || eventSettings === void 0 ? void 0 : eventSettings.systemTextOverrides) &&
        Object.keys(eventSettings.systemTextOverrides).length > 0 &&
        getMatchingLocale(locale, eventSettings.systemTextOverrides);
    const regPathLanguageOverrides = (regPathSettings === null || regPathSettings === void 0 ? void 0 : regPathSettings.systemTextOverrides) &&
        Object.keys(regPathSettings.systemTextOverrides).length > 0 &&
        getMatchingLocale(locale, regPathSettings.systemTextOverrides);
    const settings = Object.assign({}, eventLanguageOverrides, regPathLanguageOverrides);
    if (Object.keys(settings).length <= 0) {
        return;
    }
    return registerTranslation(settings, locale, context);
};
/**
 * Thunked action wrapper so apps don't have to dispatch the action conditionally
 */
const loadLanguageManagementSettings = (eventSnapshot, regPathId, textPackage) => async (dispatch) => {
    var _a, _b, _c;
    const loadLanguageManagementSettingsAction = createLoadLanguageManagementSettingsAction(eventSnapshot.languageManagementSettingsSnapshot, (_c = (_b = (_a = eventSnapshot.registrationSettings) === null || _a === void 0 ? void 0 : _a.registrationPaths) === null || _b === void 0 ? void 0 : _b[regPathId]) === null || _c === void 0 ? void 0 : _c.languageManagementSettingsSnapshot, textPackage);
    if (loadLanguageManagementSettingsAction) {
        dispatch(loadLanguageManagementSettingsAction);
    }
};
export default loadLanguageManagementSettings;
